import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    staffList: [],
    staff: null,
    loading: false,
    error: null,
    response: null,
    status: "idle",
};

const staffSlice = createSlice({
    name: "staff",
    initialState,
    reducers: {
        getRequest: (state) => {
            state.loading = true;
            state.error = false;
            state.response = null;
        },
        getSuccess: (state, action) => {
            state.loading = false;
            state.error = false;
            state.response = action.payload;
            // Set staffList if the payload is an array of staff
            if (Array.isArray(action.payload)) {
                // Merge lists and remove duplicates based on _id
                const newList = action.payload;
                const existingList = state.staffList || [];
                
                const combined = [...existingList];
                newList.forEach(item => {
                    if (!combined.find(e => e._id === item._id)) {
                        combined.push(item);
                    }
                });
                state.staffList = combined;
            } else if (action.payload && action.payload.message) {
                state.response = action.payload.message;
            }
        },
        getFailed: (state, action) => {
            state.loading = false;
            state.error = true;
            state.response = action.payload;
        },
        getError: (state, action) => {
            state.loading = false;
            state.error = true;
            state.response = action.payload;
        },
        doneSuccess: (state, action) => {
            state.loading = false;
            state.error = false;
            state.response = null;
            state.staff = action.payload;
            state.status = "added";
        },
        getDeleteSuccess: (state) => {
            state.loading = false;
            state.error = false;
            state.response = null;
        },
        underControl: (state) => {
            state.loading = false;
            state.response = null;
            state.status = "idle";
        },
        authRequest: (state) => {
            state.loading = true;
            state.error = false;
        },
        authSuccess: (state, action) => {
            state.loading = false;
            state.error = false;
            state.staff = action.payload;
            state.status = "success";
        },
        authFailed: (state, action) => {
            state.loading = false;
            state.error = true;
            state.response = action.payload;
            state.status = "failed";
        },
        authError: (state, action) => {
            state.loading = false;
            state.error = true;
            state.response = action.payload;
            state.status = "error";
        },
        authLogout: (state) => {
            state.staff = null;
            state.status = "logout";
        },
        clearStaffList: (state) => {
            state.staffList = [];
        }
    },
});

export const {
    getRequest,
    getSuccess,
    getFailed,
    getError,
    doneSuccess,
    getDeleteSuccess,
    underControl,
    authRequest,
    authSuccess,
    authFailed,
    authError,
    authLogout,
    clearStaffList,
} = staffSlice.actions;

export default staffSlice.reducer;

